import React from 'react';
import { Link } from 'react-router-dom';
import HeaderOne from './HeaderOne';
import FooterOne from './FooterOne';

const PrivacyPolicy = () => {
  return (
    <>
      <HeaderOne />

      {/* Inner Header */}
      <section
  className="section-padding inner-header"
  style={{ backgroundColor: '#fff1e6',marginBottom: '30px',padding: '20px 0', }}
>
  <div className="container">
    <div className="row">
      <div className="col-md-12 text-center">
        <h1
          className="mt-0 mb-3"
          style={{fontSize: '24px', fontWeight: 'bold',color: '#0d102d', }}>
          Privacy & Policy
        </h1>
        <div className="breadcrumbs">
          <p className="mb-0" style={{ color: '#0d102d' }}>
            <Link to="/" style={{ color: '#e96125',fontWeight: 'bold' }}>Home</Link> 
            <span style={{ margin: '0 6px', fontWeight: 'bold' }}>{'>>'}</span>
            <span style={{ color: '#e96125',fontWeight: 'bold' }}> Privacy & Policy</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* End Inner Header */}

      {/* About */}
      <section className="section-padding bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 pl-12 pr-6">
            <p
  style={{color: '#333', fontSize: '14px',textAlign: 'justify',fontWeight: 500,fontFamily: "'Maven Pro', sans-serif",marginBottom: '16px',lineHeight: '22px'
  }}
>
  This Privacy Policy is an electronic record in the form of an electronic contract formed under the Information Technology Act, 2000 and the rules made thereunder and the amended provisions pertaining to electronic documents/records in various statutes as amended by the Information Technology Act, 2000. This Privacy Policy does not require any physical, electronic or digital signature.
  This document is published and shall be construed in accordance with the provisions of the Information Technology (Reasonable security practices and procedures and sensitive personal data of information) rules, 2011 under the Information Technology Act, 2000; that require publishing of the Privacy Policy for collection, use, storage and transfer of sensitive personal data or information.
  Please read this Privacy Policy carefully. By using the Website, you indicate that you understand, agree and consent to this Privacy Policy. If you do not agree with the terms of this Privacy Policy, please do not use this Website.
  By providing us your Information or by making use of the facilities provided by the Website, you hereby consent to the collection, storage, processing, and transfer of any or all of your Personal Information and Non-Personal Information by us as specified under this Privacy Policy. You further agree that such collection, use, storage and transfer of your Information shall not cause any loss or wrongful gain to you or any other person.
  This privacy notice reveals the privacy practices for aswikamart.com.
  <br />
  This privacy notice applies exclusively to data gathered by this site. It notifies you of the following:
  <br />
  1. What identifiable information is taken from you through the site, how it is utilized and with whom it might be shared.
  <br />
  2. What choices are there for you with respect to the utilization of your information.
  <br />
  3. The security methodology set up to ensure that there is no abuse of your data.
  <br />
  4. How you can revise any error in the data.
</p>


<h5 className="mt-2" style={{ fontWeight: 500, color: '#e96125',  fontSize: '1.25rem' }}>
  Data Collection, Use, and Sharing:
</h5>


              <p style={{color: '#333', fontSize: '14px',textAlign: 'justify',fontWeight: 500,fontFamily: "'Maven Pro', sans-serif",marginBottom: '16px',lineHeight: '22px'}}>
                We are the sole proprietors of the data collected on this site. We just gather data that you intentionally give us by means of email or other direct contact from you. We will utilize your data to connect with you, with respect to the reason you reach us, and to reach you with any of our fabulous gifts & offers, or to also facilitate your delivery better. We won't impart your data to any outsider outside of our association, other than as an important necessity to fulfill your demand, e.g. to deliver a request.
                Unless you ask us not to, we may get in touch with you by means of email later on to enlighten you about specials, new items or services, or changes to this privacy approach.
                You may quit any future contacts from us at any time. You can have access to the following by contacting us through the email address or contact number given on our site:
                1. See what information we have about you.
                2. Change/amend any information we have about you.
                3. Have we removed any information about you.
                4. Raise any concern you have about our utilization of your information.
              </p>

              <h5 className="mt-2" style={{ fontWeight: 500, color: '#e96125',fontSize: '1.25rem',  }}>Security:</h5>
              <p style={{color: '#333', fontSize: '14px',textAlign: 'justify',fontWeight: 500,fontFamily: "'Maven Pro', sans-serif",marginBottom: '16px',lineHeight: '22px',lineHeight: '22px'
  }}>
                All information gathered on our Website is securely stored within our controlled database. The database is stored on servers secured behind a firewall; access to the servers is password-protected and is strictly limited. However, as effective as our security measures are, no security system is impenetrable. We cannot guarantee the security of our database, nor can we guarantee that information you supply will not be intercepted while being transmitted to us over the Internet. And, of course, any information you include in a posting to the discussion areas is available to anyone with Internet access.
              </p>

              <h5 className="mt-2" style={{ fontWeight: 500, color: '#e96125',fontSize: '1.25rem'  }}>Enrollment:</h5>
              <p style={{color: '#333', fontSize: '14px',textAlign: 'justify',fontWeight: 500,fontFamily: "'Maven Pro', sans-serif",marginBottom: '16px',lineHeight: '22px'
  }}>
                In order to utilize this site, the user must first complete the enrollment form. During this, the user is required to give certain information like name and email address. This data is utilized to reach you about the items/services on our site for which you have shown interest.
              </p>

              <h5 className="mt-2" style={{ fontWeight: 500, color: '#e96125',fontSize: '1.25rem'  }}>COOKIES:</h5>
              <p style={{color: '#333', fontSize: '14px',textAlign: 'justify',fontWeight: 500,fontFamily: "'Maven Pro', sans-serif",marginBottom: '16px',lineHeight: '22px'}}>
                To improve the responsiveness of the site for our users, we may use "cookies" or similar electronic tools to collect information to assign each visitor a unique, random number as a User Identification (User ID) to understand the user's individual interests using the Identified Computer. Unless you voluntarily identify yourself (through registration, for example), we will have no way of knowing who you are, even if we assign a cookie to your computer. The only personal information a cookie can contain is information you supply (an example of this is when you ask for our Personalised Horoscope). A cookie cannot read data off your hard drive. Our advertisers may also assign their own cookies to your browser (if you click on their ads), a process that we do not control.
              </p>

              <h5 className="mt-2" style={{ fontWeight: 500, color: '#e96125',fontSize: '1.25rem'  }}>Orders:</h5>
              <p style={{color: '#333', fontSize: '14px',textAlign: 'justify',fontWeight: 500,fontFamily: "'Maven Pro', sans-serif",marginBottom: '16px',lineHeight: '22px'}}>
                We ask for data from you on our order form. To purchase from us, you should give contact information (like name and delivering address) and payment information (like Card number, lapse date). This information is utilized for billing purposes and to dispatch your requests. In the event where we experience difficulty preparing a request, we'll utilize this data to get in touch with you.
              </p>

              <h5 className="mt-2" style={{ fontWeight: 500, color: '#e96125',fontSize: '1.25rem',lineHeight: '22px'  }}>Grievance Redressal:</h5>
              <p style={{color: '#333', fontSize: '14px',textAlign: 'justify',fontWeight: 500,fontFamily: "'Maven Pro', sans-serif",marginBottom: '16px',lineHeight: '22px'}}>
                Redressal Mechanism: Any complaints, abuse or concerns with regards to content and or comment or breach of these terms shall be immediately informed to the designated Grievance Officer as mentioned below via in writing or through email to: info@aswikamart.com or support@aswikamart.com.
              </p>
            </div>
          </div>
        </div>
      </section>
      

      {/* Footer */}
      <section>
        <FooterOne />
      </section>

     
    </>
  );
};

export default PrivacyPolicy;